<script setup>
import Modal from "@/components/ModalComponent.vue";
import { useStore } from "vuex";
import { computed, ref } from "@vue/reactivity";

const qrcode_baseurl = process.env.VUE_APP_QRCODE_BASEURL;
const store = useStore();
const props = defineProps({
  dataPostel: {
    type: Object,
    required: false,
  },
  dataLength: Number,
  pageLength: Number,
  currentPage: Number,
  offset: Number,
  size: Number,
});

const lastIndex = computed(() => {
  if (props.offset + props.size <= props.dataLength) {
    return props.offset + 10;
  } else {
    return props.dataLength;
  }
});

let viewperangkat_ = ref();
const openModal = (data_body) => {
  store.state.openModal = true;
  viewperangkat_.value = data_body;
};

const nol = (x) => {
  const y = x > 9 ? (x > 99 ? x : "" + x) : "0" + x;
  return y;
};
</script>

<template>
  <div>
    <div class="table-responsive">
      <table class="table mb-0">
        <thead>
          <tr>
            <th
              class="
                text-center text-uppercase text-secondary text-xxs
                font-weight-bolder
                opacity-7
              "
            >
              No.
            </th>
            <th
              class="
                text-center text-secondary text-xxs
                font-weight-bolder
                opacity-7
              "
            >
              TGL. UPLOAD
            </th>
            <th
              class="
                text-center text-secondary text-xxs
                font-weight-bolder
                opacity-7
              "
            >
              STATION
            </th>
            <th
              class="
                text-center text-secondary text-xxs
                font-weight-bolder
                opacity-7
              "
            >
              KETERANGAN
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="data, index in props.dataPostel" :key="index">
            <td class="text-center align-middle text-sm">
              <small>{{
                props.currentPage > 0
                  ? index + 1 + props.currentPage * 10
                  : index + 1
              }}</small>
            </td>
            <td class="text-center align-middle">
              <small>{{
                `${nol(data.tanggalonline[2])} - ${nol(
                  data.tanggalonline[1]
                )} - ${nol(data.tanggalonline[0])}`
              }}</small>
            </td>
            <td class="text-center align-middle">
              <small>{{ data.earthstationname }}</small>
            </td>
            <td class="text-center align-middle">
              <small
                >ID STASIUN BUMI : {{ data.idstasiunbumi }} <br />
                QR CODE : {{ data.qrcodeid }}</small
              >
            </td>
            <td class="text-center align-middle">
              <button
                type="button"
                class="btn btn-success btn-sm px-2 py-1"
                data-bs-toggle="modal"
                data-bs-target="#mantap"
                @click="openModal(data)"
              >
                <i class="fa fa-eye text-white"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="row px-3 mt-2">
        <div class="col-6">
          <h6>
            Showing
            {{ props.offset  }}
            to
            {{ lastIndex }}
            from {{ props.dataLength }} entries
          </h6>
        </div>
        <div class="col-6">
          <div class="float-end">
            <slot name="button"></slot>
          </div>
        </div>
      </div>
    </div>
    <!-- modal -->
    <Modal
      :modalName="'mantap'"
      :isHeader="true"
      modalTitle="Detail Perangkat"
      :isFooter="false"
    >
      <template #body>
        <div class="p-0">
          <div v-if="viewperangkat_ !== undefined">
            <table class="table table-bordered">
              <tr>
                <th width="150" height="50">No Registrasi</th>
                <td>:&nbsp;</td>
                <td>{{ viewperangkat_.noregistrasi }}</td>
              </tr>
              <tr>
                <th width="150" height="50">ID Aplikasi</th>
                <td>:&nbsp;</td>
                <td>{{ viewperangkat_.applid }}</td>
              </tr>
              <tr>
                <th width="150" height="50">Status</th>
                <td>:&nbsp;</td>
                <td>
                  {{
                    viewperangkat_.statussimf == "Granted"
                      ? "AKTIF"
                      : viewperangkat_.statussimf ==
                        "Granted (Under modification)"
                      ? "AKTIF (PRE)"
                      : viewperangkat_.statussimf == "Prelim. Canceled"
                      ? "AKTIF (PRE)"
                      : "TIDAK AKTIF"
                  }}
                </td>
              </tr>
              <tr>
                <th width="150" height="50">Station</th>
                <td>:&nbsp;</td>
                <td>{{ viewperangkat_.earthstationname }}</td>
              </tr>
              <tr>
                <th width="150" height="50">ID Stasiun Bumi</th>
                <td>:&nbsp;</td>
                <td>{{ viewperangkat_.idstasiunbumi }}</td>
              </tr>
              <tr>
                <th width="150" height="50">Posisi</th>
                <td>:&nbsp;</td>
                <td>
                  {{ viewperangkat_.longdec }}, {{ viewperangkat_.latdec }}
                </td>
              </tr>
              <tr>
                <th width="150" height="50">Alamat</th>
                <td>:&nbsp;</td>
                <td class="break-line-alamat">{{ viewperangkat_.alamat }}</td>
              </tr>
              <tr>
                <th width="150" height="50">Provinsi</th>
                <td>:&nbsp;</td>
                <td>{{ viewperangkat_.provinsi }}</td>
              </tr>
              <tr>
                <th width="150" height="50">Kabupaten</th>
                <td>:&nbsp;</td>
                <td>{{ viewperangkat_.kabupatenkota }}</td>
              </tr>
              <tr>
                <th width="150" height="50">QR Code</th>
                <td>:&nbsp;</td>
                <td>
                  <span class="text-center">
                    <img
                      :src="`${qrcode_baseurl}/${viewperangkat_.tahunonline}/${viewperangkat_.qrfolder}/${viewperangkat_.qrcodeid}.png`"
                      style="width: 50%; height: 50"
                    /><br /><b class="ms-5">{{ viewperangkat_.qrcodeid }}</b>
                  </span>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div>
          <button class="btn btn-success float-end" data-bs-dismiss="modal">
            Tutup
          </button>
        </div>
      </template>
    </Modal>
  </div>
</template>
